import sbpServices from "../../../services/sbpServices";
import insurercreater from "./insurerActionCreaters";
import actioncreator from "./caseInformationActionCreater";
export const _getInsurerName =
  (_patientlastname, insurer) => async (dispatch) => {
    try {
      /* istanbul ignore next */
      dispatch(insurercreater.insurerLoadStart());
      const res = await sbpServices
        ._getinsurerInfo(_patientlastname, insurer)
        .then((result) => {
          return result;
        });
      /* istanbul ignore next */
      if (res.status === 200) {
        /* istanbul ignore next */
        dispatch(actioncreator.PatientInfoLoadClear());
        dispatch(insurercreater.insurerLoadSuccess(res.data));
      }
      if (res.status === 204) {       
        dispatch(insurercreater.insurerLoadErrors(res));
      }
    } catch (err) {
      /* istanbul ignore next */
      dispatch(insurercreater.insurerLoadErrors(err.response));
    }
  };

export const _getInsurerList = () => async (dispatch) => {
  try {
    /* istanbul ignore next */
    dispatch(insurercreater.insurerListLoadStart());
    const res = await sbpServices._getinsurerList().then((result) => {
      return result;
    });
    /* istanbul ignore next */
    if (res.status === 200) {
      dispatch(insurercreater.insurerLoadData(res.data));
    }
    if (res.status === 204) {       
      dispatch(insurercreater.insurerLoadErrors(res));
    }
  } catch (err) {
    /* istanbul ignore next */
    dispatch(insurercreater.insurerLoadErrors(err.response));
  }
};
